import { render, staticRenderFns } from "./detailMessageLog.vue?vue&type=template&id=55a34a16&scoped=true&"
import script from "./detailMessageLog.vue?vue&type=script&lang=js&"
export * from "./detailMessageLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a34a16",
  null
  
)

export default component.exports